export enum PGW_SETTLEMENT_TYPES_VALUE {
  PGW_MERCHANT = 'PGW_MERCHANT',
  PGW_PROVIDER_SEAMLESS = 'PGW_PROVIDER_SEAMLESS',
  DISABLE_PGW = 'DISABLE_PGW'
}

export enum PGW_SETTLEMENT_TYPES_VIEW_VALUE {
  PGW_MERCHANT = 'PGW Merchant',
  PGW_PROVIDER_SEAMLESS = 'PGW Provider Seamless',
  DISABLE_PGW = 'Disable PGW'
}

export const PgwSettlementTypes = [
  { value: PGW_SETTLEMENT_TYPES_VALUE.PGW_MERCHANT, viewValue: PGW_SETTLEMENT_TYPES_VIEW_VALUE.PGW_MERCHANT },
  { value: PGW_SETTLEMENT_TYPES_VALUE.PGW_PROVIDER_SEAMLESS, viewValue: PGW_SETTLEMENT_TYPES_VIEW_VALUE.PGW_PROVIDER_SEAMLESS },
  { value: PGW_SETTLEMENT_TYPES_VALUE.DISABLE_PGW, viewValue: PGW_SETTLEMENT_TYPES_VIEW_VALUE.DISABLE_PGW},
];

export enum PGW_PMT_TXN_SOURCE {
  NONAPP = 'NONAPP',
  APP = 'APP'
}

export enum PGW_PMT_STATUS {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
}
